import React from "react"
import TagManager from "react-gtm-module"

export class GTAG extends React.Component {
  componentDidMount() {
    const script = document.createElement("script")
    script.src = "https://www.googletagmanager.com/gtag/js?id=DC-6953330"
    script.async = true
    document.body.appendChild(script)
    const dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())
    gtag("config", "DC-6953330")

    const linkedin_partner_id = "151643"
    const linkedIn = window._linkedin_data_partner_ids || []
    linkedIn.push(linkedin_partner_id)
    ;(function() {
      const b = document.createElement("script")
      b.type = "text/javascript"
      b.async = true
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"
      document.body.appendChild(b)
    })()

    const tagManagerArgs = {
      gtmId: "GTM-TSXB532",
    }
    TagManager.initialize(tagManagerArgs)
  }
  render() {
    return <></>
  }
}
